import type { SettingDefinition, SettingsCategory } from '../models/settings-hub.model';

import { SETTINGS_LAYOUT } from './settings-layout';
import { SETTINGS_POOL } from './settings-pool';

function settingById(id: string): SettingDefinition {
    const setting = SETTINGS_POOL.get(id);

    if (!setting) {
        throw new Error(`Unknown setting in the layout of the settings: ${id}`);
    }

    return setting;
}

export const SETTINGS_REGISTRY: SettingsCategory[] = SETTINGS_LAYOUT.map(category => ({
    ...category,
    subcategories: category.subcategories.map(subcategory => ({
        ...subcategory,
        cards: subcategory.cards.map(card => ({ ...card, settings: card.settings.map(settingById) }))
    }))
}));
